import styled from 'styled-components'

export const AdsTypes = styled.div`
  background-color: ${({ theme }) => theme.colors.brownBack};
  padding: 2.4rem 3rem;

  ${({ theme }) => theme.breakpoints.down('desktop')} {
    padding: 2.4rem 2rem;
  }
`

export const TypesList = styled.ul`
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  > li:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.greyContour};
    padding-bottom: 1.6rem;
  }
`

export const TypesListItem = styled.li``

export const TypesListItemButton = styled.button`
  ${({ theme }) => theme.textStyles.firaSansSmMedium};
  color: ${({ theme }) => theme.colors.pureBlack};
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  margin-top: 1.6rem;
  text-decoration: underline;
  text-align: left;
`

export const Title = styled.h4`
  ${({ theme }) => theme.textStyles.firaSansTextBaseSemiBold};
  color: ${({ theme }) => theme.colors.pureBlack};
  margin: 0 0 0.5rem 0;
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBase};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
`
